export default "__VITE_ASSET__DmPooPuJ__"